import React from 'react';
import { useT } from '@repo/common';

const HeaderItem = ({ children, width, isGrow = false }) => {
  return (
    <div
      className={`flex justify-center items-center p-4 gap-[10px] relative z-10 ${
        isGrow ? 'flex-1' : 'flex-shrink-0'
      }`}
      style={!isGrow ? { width: width } : {}}
    >
      <span className='typo-b13Strong text-text-secondary'>{children}</span>
    </div>
  );
};

const PaymentsListHeader = () => {
  const t = useT();

  return (
    <div className='flex flex-col w-full items-start px-2 bg-grayscale-gray02/30 rounded-t-[30px]'>
      <div className='flex w-full'>
        <HeaderItem width='130px'>{t('Invoice #', '주문 번호')}</HeaderItem>
        <HeaderItem width='120px'>{t('Date', '날짜')}</HeaderItem>
        <HeaderItem isGrow={true}>{t('Item', '상품')}</HeaderItem>
        <HeaderItem width='100px'>{t('Amount', '금액')}</HeaderItem>
        <HeaderItem width='100px'>{t('Status', '상태')}</HeaderItem>
        <HeaderItem width='160px'>{t('Receipt', '영수증')}</HeaderItem>
      </div>
      <div className='bg-grayscale-gray02/70 h-5' />
    </div>
  );
};

export default PaymentsListHeader;
